const cureny = process.env.VUE_APP_CURENV;
export const serverIp =
    process.env.VUE_APP_CURENV === 'localhost' ? 'gate.yilanbiaoge.cn' :
    // process.env.VUE_APP_CURENV === 'localhost' ? 'localhost:8096' :
    process.env.VUE_APP_CURENV === 'development' ? '49.233.43.158:8096' :
    process.env.VUE_APP_CURENV === 'production' ? 'gate.yilanbiaoge.cn' :
    process.env.VUE_APP_CURENV

let title = '一览表格'

export function getTitle() {
    return title
}
export function setTitle(newTitle) {
    title = newTitle
}

// 将函数挂载到全局window对象上，以便在index.html中访问
window.config = {
    getTitle,
    setTitle
}